module.exports = __webpack_public_path__ + "img/delivery-box.1a64c592.png";